import { render, staticRenderFns } from "./TtiSvgIcon.vue?vue&type=template&id=68ab200b&scoped=true"
import script from "./TtiSvgIcon.vue?vue&type=script&lang=ts"
export * from "./TtiSvgIcon.vue?vue&type=script&lang=ts"
import style0 from "./TtiSvgIcon.vue?vue&type=style&index=0&id=68ab200b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ab200b",
  null
  
)

export default component.exports